/**
 * ContractorIntakeCockpit — Cockpit-language frame for /contractor-intake.
 *
 * Wraps ContractorIntake with a Cockpit Masthead summarizing the intake
 * pipeline (Grow / Find Work / Partner) and embeds the original interactive
 * intake forms unchanged.
 */
import {
  CockpitPage, CockpitMasthead, HeroMetric, HeroDivider, CockpitKpiStrip,
} from "@/components/cockpit/CockpitShell";
import ContractorIntake from "./ContractorIntake";

export default function ContractorIntakeCockpit() {
  return (
    <CockpitPage>
      <CockpitMasthead
        title="Contractor Intake"
        right={(
          <>
            <HeroMetric label="Paths" value={3} hero />
            <HeroDivider />
            <HeroMetric label="Grow" value="Business" />
            <HeroMetric label="Find" value="Work" />
            <HeroMetric label="Partner" value="Supplier" />
          </>
        )}
      />
      <div className="cockpit-surface -mx-6">
        <div className="px-6">
          <ContractorIntake />
        </div>
      </div>
    </CockpitPage>
  );
}
